import { ServerFetch } from '../main-model'

export default class SaleStationModel extends ServerFetch {
    getSaleStationBy = (data) => this.authFetch({
        url: 'sale-station/getSaleStationBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}